import React from 'react';
import { useNavigate } from 'react-router-dom';
import MainLayout from '@/components/layout/MainLayout';
import { PageHeader } from '@/components/layout/PageHeader';
import { Button } from '@/components/ui/button';
import { AlertBanner } from '@/components/ui/AlertBanner';
import { useGlobalProject } from '@/contexts/GlobalProjectContext';
import { ListBulletIcon } from '@heroicons/react/24/outline';

/**
 * In-development placeholder for interactive Gantt.
 * Routed at /app/gantt; guarded in production by InDevelopmentRouteGuard in App.
 */
const GanttPage: React.FC = () => {
  const navigate = useNavigate();
  const { selectedProject } = useGlobalProject();

  return (
    <MainLayout title="Gantt">
      <div className="p-4 lg:p-6 space-y-4 max-w-[1600px]">
        <PageHeader
          title="Gantt chart"
          subtitle="Interactive timeline · in development"
        />
        <AlertBanner variant="default" title="Work in progress">
          The full interactive Gantt view is under active development. Use Activities for the
          activity list, or open a project from Projects for detail tabs.
        </AlertBanner>
        <div className="flex flex-wrap gap-2">
          <Button variant="outline" size="sm" onClick={() => navigate('/app/activities')}>
            <ListBulletIcon className="mr-2 h-3.5 w-3.5" />
            Activities
          </Button>
          {selectedProject && (
            <Button variant="outline" size="sm" onClick={() => navigate(`/app/projects/${selectedProject.id}`)}>
              Current project
            </Button>
          )}
          <Button variant="ghost" size="sm" onClick={() => navigate('/app/projects')}>
            All projects
          </Button>
        </div>
      </div>
    </MainLayout>
  );
};

export default GanttPage;
